import { Injectable } from '@angular/core';
import { Tag } from './tag';
import { ProjectService } from './project.service'
import { Project } from './project'

@Injectable()
export class TagService {
  private _counter = 1

  constructor(
    private projects: ProjectService
  ) {
    this.projects.tags = this
  }

  new(p: Project, params: Object) {
    new Tag(this, p, `t${this._counter++}`, params['title'], params['items'])
  }


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag.service.ts